export default "__VITE_ASSET__BEeLA4_T__"